import Plyr from 'plyr';
import Vue from 'vue';

Vue.component('video-component', {
    data() {
        return {
            video: null,
            videoStop: true,
            videoPause: false,
            videoPlaying: false,
        };
    },

    mounted() {
        Vue.nextTick(() => {
            Vue.nextTick(this.setupVideo);
        });
    },

    watch: {

    },

    methods: {
        playVideo() {
            this.video.play();
            this.videoPlaying = true;
        },

        /**
        * Play the intro video
        */
        setupVideo() {
            this.video = new Plyr(this.$refs.video, {
                controls: ['progress', 'fullscreen'],
            });

            if (!this.video) {
                return;
            }

            this.video.on('play', (event) => {
                this.videoStop = false;
                this.videoPause = false;
                this.videoPlaying = true;
                this.$root.cursor.DOM.play.classList.add('playing');

                if (window.matchMedia('(max-width: 767px)').matches) {
                    this.video.fullscreen.enter();
                }
            });

            this.video.on('pause', (event) => {
                this.videoStop = false;
                this.videoPause = true;
                this.videoPlaying = false;
                this.$root.cursor.DOM.play.classList.remove('playing');
            });

            this.video.on('seeking', (event) => {
                this.videoStop = false;
                this.videoPause = false;
                this.videoPlaying = true;
            });

            this.video.on('ended', (event) => {
                this.videoStop = true;
                this.videoPause = false;
                this.videoPlaying = false;
            });
        },
    },
});
